import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const defaultState = () => ({
  user: null,
  cameraModel: null,
  cameraFirmware: null,
  cameraSerial: null,
  cameraId: null,
  devices: [],
  currentDeviceId: null,
  currentDevice: null,
  currentGeofenceId: null,
  mapLayer: null,
  darkTheme: false,
  currentMapZoomLevel: 0,
  currentMapLocation: null,
  newGeofenceRadius: 0,
  cameFromView: null,
});

export default new Vuex.Store({
  state: defaultState(),
  mutations: {
    // eslint-disable-next-line
    reset(state/* , payload */) {
      // eslint-disable-next-line
      state = defaultState();
    },
    user(state, payload) {
      state.user = payload;
    },
    cameraModel(state, payload) {
      state.cameraModel = payload;
    },
    cameraFirmware(state, payload) {
      state.cameraFirmware = payload;
    },
    cameraSerial(state, payload) {
      state.cameraSerial = payload;
    },
    cameraId(state, payload) {
      state.cameraId = payload;
    },
    devices(state, payload) {
      state.devices = payload;
    },
    currentDeviceId(state, payload) {
      state.currentDeviceId = payload;
    },
    currentDevice(state, payload) {
      state.currentDevice = payload;
    },
    currentGeofenceId(state, payload) {
      state.currentGeofenceId = payload;
    },
    currentMapZoomLevel(state, payload) {
      state.currentMapZoomLevel = payload;
    },
    currentMapLocation(state, payload) {
      state.currentMapLocation = payload;
    },
    mapLayer(state, payload) {
      state.mapLayer = payload;
    },
    darkTheme(state, payload) {
      state.darkTheme = payload;
    },
    newGeofenceRadius(state, payload) {
      state.newGeofenceRadius = payload;
    },
    cameFromView(state, payload) {
      state.cameFromView = payload;
    },
  },
  actions: {
  },
  getters: {
    deviceById: (state) => (id) => {
      const devices = state.devices.filter((device) => device.id === id);
      return devices[0];
    },
  },
  modules: {
  },
});
